import { render, staticRenderFns } from "./PurchaseQnA.vue?vue&type=template&id=1f505d3f&"
import script from "./PurchaseQnA.vue?vue&type=script&lang=js&"
export * from "./PurchaseQnA.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports